import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';

export const useScanToPayModalSafeAreaInsets = () => {
  const { bottom } = useSafeAreaInsets();

  return useStyle(() => ({ paddingBottom: Math.max(bottom, theme.spacing['10']) }), [bottom]);
};
